import { useAppDispatch } from "../../../redux/hooks";
import { ProductsWithCustomSnListInterface } from "../../../redux/interfaces/receipt.interface";
import { TableItemId } from "../../../components/tables/TableWidget";
import ActionMenu from "../../../components/actionMenu/ActionMenu";
import {
  deleteProductWithCustomSN,
  fetchPrintProductSerialNumber,
  fetchToggleValidateProductWithCustomSN,
} from "../../../redux/api/receipt.api";
import { useNavigate } from "react-router-dom";
import { crudRoutes, receptionRoutes } from "../../../router/routesConstants";
import { setProductWithCustomBc } from "../../../redux/reducer/receipt.reducer";

function ProductsWithCustomBcActionButtons({
  crudData,
  itemId,
}: {
  itemId: TableItemId;
  crudData: ProductsWithCustomSnListInterface;
}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleValidateProduct = () => {
    dispatch(
      fetchToggleValidateProductWithCustomSN({
        id: itemId,
      }),
    );
  };

  const handleCreateQrPdf = () => {
    dispatch(
      fetchPrintProductSerialNumber({
        id: itemId,
      }),
    );
  };

  const handleDeleteProduct = () => {
    dispatch(
      deleteProductWithCustomSN({
        id: itemId,
      }),
    );
  };

  const editProduct = () => {
    dispatch(setProductWithCustomBc(crudData));

    navigate(
      `/${receptionRoutes.productsWithCustomBc}/${receptionRoutes.productsWithoutSn}/${itemId}/${crudRoutes.create}`,
    );
  };

  return (
    <ActionMenu
      minItemsForMenu={2}
      title={crudData.numeProdus}
      ariaLabel={`Actiuni pentru produsul ${crudData.numeProdus}`}
      items={[
        {
          id: "validate",
          label: "Validare",
          icon: "VALIDATE",
          color: "success",
          tooltip: crudData.validated
            ? "Produsul este deja validat."
            : "Valideaza produsul pentru a permite tiparirea codului.",
          disabled: !!crudData.validated,
          withConfirmationModal: {
            modalTitle: "Validare produs",
            modalSubtitle: "Doriti sa validati produsul?",
            modalRightButtonOnClick: handleValidateProduct,
          },
        },
        {
          id: "print",
          label: "Printeaza",
          icon: "PRINT",
          kind: "download",
          disabled: !crudData.validated,
          tooltip: !crudData.validated
            ? "Valideaza produsul inainte de descarcarea codului."
            : "Descarca PDF-ul cu codul produsului validat pentru tiparire.",
          withConfirmationModal: {
            modalTitle: "Printare QR",
            modalSubtitle: "Doriti sa printati QR-ul?",
            modalRightButtonOnClick: handleCreateQrPdf,
          },
        },
        {
          id: "edit",
          label: "Editare",
          icon: "EDIT",
          tooltip: "Modifica datele si codul personalizat al produsului.",
          onClick: editProduct,
        },
        {
          id: "toggle-deleted",
          dividerBefore: true,
          label: crudData.deleted ? "Restaurare" : "Stergere",
          icon: crudData.deleted ? "RESTORE" : "DELETE",
          color: crudData.deleted ? "secondary" : "error",
          tooltip: crudData.deleted
            ? "Restaureaza produsul sters."
            : "Sterge produsul dupa confirmare.",
          withConfirmationModal: {
            modalTitle: "Stergere produs",
            modalSubtitle: "Doriti sa stergeti produsul?",
            modalRightButtonOnClick: handleDeleteProduct,
          },
        },
      ]}
    />
  );
}

export default ProductsWithCustomBcActionButtons;
